import React from "react";
import styled from "styled-components";
const Indicator = styled.span `
    color: ${(props) => props.theme.primary};
    margin-left: 4px;
`;
const MandatoryIndicator = () => (React.createElement(Indicator, null, "*"));
export default MandatoryIndicator;
